import { render, staticRenderFns } from "./PolicyHelpList.vue?vue&type=template&id=7847df5a&"
import script from "./PolicyHelpList.vue?vue&type=script&lang=js&"
export * from "./PolicyHelpList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports